import { ColumnsType } from "antd/es/table";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { ISubAccountData } from "@/store/SubAccountStore";
import { StatusText } from "@/pages/child-customer/components/status-text";
import { ChildBalance } from "@/pages/child-customer/view/child-manage/components/child-balance";
import { ChildCoupon } from "@/pages/child-customer/view/child-manage/components/child-coupon";
import { ChildPermission } from "@/pages/child-customer/view/child-manage/components/child-permission";
import { ChildOperation } from "@/pages/child-customer/view/child-manage/components/child-operation";
import { DingTalkChildUsername } from "@/pages/child-customer/view/child-manage/components/child-username";
import { RemarkCell } from "@/pages/child-customer/components/remark-cell";
const t = getTranslateNsT("childManager");
const centerT = getTranslateNsT("center");

export const columns: ColumnsType<ISubAccountData> = [
  {
    title: t("dingtalk_subaccount_userid"),
    dataIndex: "id",
    width: 120,
  },
  {
    title: t("dingtalk_subaccount_dingtalkid"),
    dataIndex: "dingTalkId",
    width: 120,
  },
  {
    title: t("dingtalk_subaccount_username"),
    render: ({ subUserName, isLeader }) => (
      <DingTalkChildUsername userName={subUserName} isLeader={isLeader} />
    ),
    width: 100,
  },
  {
    title: t("dingtalk_subaccount_position"),
    dataIndex: "posts",
    width: 140,
  },
  {
    title: centerT("user_com_childManage_head_tel"),
    dataIndex: "phone",
    width: 100,
  },
  {
    title: centerT("user_com_childManage_head_email"),
    dataIndex: "email",
    width: 100,
  },
  {
    title: centerT("user_com_childManage_head_remark"),
    render: (v) => <RemarkCell {...v} isDingTalk={true} />,
    width: 120,
  },
  {
    title: centerT("user_com_childManage_head_status"),
    render: ({ status }) => (
      <StatusText
        status={status}
        text={centerT(`user_com_childManage_head_status_${status}`)}
      />
    ),
  },
  {
    title: centerT("user_com_childManage_head_balance"),
    render: (v) => <ChildBalance {...v} />,
    width: 100,
  },
  {
    title: centerT("user_com_childManage_head_desktop"),
    dataIndex: "cloudCoupon",
    width: 100,
    render: (v) => (v ? `￥${v}` : ""),
  },
  {
    title: centerT("user_com_childManage_head_coupon"),
    render: (v) => <ChildCoupon {...v} />,
    width: 100,
  },
  {
    title: centerT("user_com_childManage_head_credit"),
    dataIndex: "credit",
    width: 100,
  },
  {
    title: centerT("user_com_childManage_head_privilege"),
    render: (v) => <ChildPermission {...v} />,
    width: 200,
  },
  {
    title: centerT("user_com_childManage_head_handle"),
    render: (v) => <ChildOperation {...v} isDingTalk={true} />,
    width: 240,
  },
];
